import { FireTruck } from "@mui/icons-material";
import { Grid, Paper, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { titleize } from "inflection";

type ItemVariantType = "supplier" | "deliverer" | "receiver";

function getStyles(variant: ItemVariantType) {
  const variants = {
    supplier: { bg: "#e8f5e9", border: "#c8e6c9", iconColor: "#2e7d32" },
    deliverer: { bg: "#e3f2fd", border: "#bbdefb", iconColor: "#1565c0" },
    receiver: { bg: "#f3e5f5", border: "#ce93d8", iconColor: "#7b1fa2" },
  };
  type VariantColors = {
    bg: string;
    border: string;
    iconColor: string;
  };
  const colors: VariantColors = variants[variant] || variants.supplier;

  return {
    backgroundColor: colors.bg,
    border: `1px solid ${colors.border}`,
    padding: 2,
    borderRadius: 5,
    "& .icon": {
      color: colors.iconColor,
    },
    "& .title": {
      color: colors.iconColor,
      fontWeight: 600,
    },
    "& .name": {
      color: grey[900],
      fontWeight: 600,
    },
    "& .email": {
      color: colors.iconColor,
      opacity: 0.8,
    },
  };
}

interface InfoCardProps {
  variant: ItemVariantType;
  personName: string;
}
const InfoCard: React.FC<InfoCardProps> = ({ variant, personName }) => {
  return (
    <Grid
      size={{
        md: 6
      }}>
      <Paper sx={{ ...getStyles(variant) }}>
        <Grid container alignItems="center" mb={1}>
          <FireTruck className="icon" sx={{ mr: 1, fontSize: 20 }} />
          <Typography variant="body2" className="title">
            {titleize(variant)}
          </Typography>
        </Grid>
        <Typography variant="body1" className="name">
          {personName}
        </Typography>
      </Paper>
    </Grid>
  );
};

export default InfoCard;
